// src/components/BuildingViews/LandPlotView.js
import React, { useState } from 'react';
import styles from './SawmillView.module.css'; // Reuse sawmill styles for now
import { ItemData } from '../../data/ItemData';

const LandPlotView = ({ playerData, onPlayerAction, onUnlockSeed, onGoBack }) => {
  const buildingLevel = playerData.buildings?.landPlot?.upgradeLevel || 0;
  const [selectedSeed, setSelectedSeed] = useState(null);
  
  const seedUnlockPrices = {
    'carrotSeed': 50,
    'cucumberSeed': 75,
    'beetSeed': 100,
    'onionSeed': 125,
    'garlicSeed': 150,
    'kaleSeed': 175,
    'greenbeanSeed': 200,
    'tomatoSeed': 250,
    'pepperSeed': 300,
    'eggplantSeed': 350,
    'cauliflowerSeed': 400,
    'pumpkinSeed': 500,
  };

  const getSeedUnlockItems = () => {
    return Object.entries(seedUnlockPrices).map(([seedKey, price]) => {
      const seedData = ItemData[seedKey];
      if (!seedData) return null;
      
      const isUnlocked = playerData.unlockedSeeds?.includes(seedKey);
      
      return {
        key: seedKey,
        name: seedData.name,
        type: 'seedUnlock',
        cost: price,
        img: seedData.img,
        description: isUnlocked ? 'Already unlocked for foraging!' : `Unlock ${seedData.name} to find while foraging. ${seedData.description}`,
        isUnlocked: isUnlocked,
        seedData: seedData
      };
    }).filter(Boolean);
  };

  const seedItems = getSeedUnlockItems();
  const canAfford = (cost) => playerData.gold >= cost;

  const handleUnlockSeed = (seedKey) => {
    if (onUnlockSeed) {
      onUnlockSeed(seedKey);
    }
  };

  return (
    <div className={styles.sawmillContainer}>
      {onGoBack && (
        <button 
          className={styles.backButton}
          onClick={onGoBack}
          title="Back to Home"
        >
          ✕
        </button>
      )}
      <div className={styles.sawmillHeader}>
        <img src="/img/icons/land_icon.png" alt="Land Plot" className={styles.sawmillIcon} />
        <div className={styles.sawmillInfo}>
          <h2>Farming & Agriculture</h2>
          <p>Level {buildingLevel}</p>
          <p className={styles.description}>
            Manage your crops and unlock new seeds for foraging
          </p>
        </div>
      </div>



      <div className={styles.sawmillTips}>
        <h4>🌱 Seed Unlocks</h4>
        <p>Purchase seed unlocks to find them while foraging in the wilderness!</p>
        
        <div className={styles.seedUnlocksGrid}>
          {seedItems.map((seed) => (
            <div 
              key={seed.key}
              className={`${styles.seedUnlockItem} ${selectedSeed === seed.key ? styles.selectedSeed : ''}`}
              onClick={() => setSelectedSeed(seed.key)}
            >
              <img src={`/img/${seed.img}`} alt={seed.name} className={styles.seedIcon} />
              <div className={styles.seedInfo}>
                <h5>{seed.name}</h5>
                <p className={styles.seedCost}>{seed.cost}G</p>
                <p className={styles.seedStatus}>
                  {seed.isUnlocked ? '✅ Unlocked' : '🔒 Locked'}
                </p>
              </div>
            </div>
          ))}
        </div>

        {selectedSeed && (
          <div className={styles.seedDetails}>
            {(() => {
              const seed = seedItems.find(s => s.key === selectedSeed);
              if (!seed) return null;
              
              return (
                <div className={styles.seedDetailsContent}>
                  <h4>{seed.name}</h4>
                  <p>{seed.description}</p>
                  <p className={styles.seedCost}>Cost: {seed.cost} Gold</p>
                  <button 
                    onClick={() => handleUnlockSeed(seed.key)}
                    disabled={!canAfford(seed.cost) || seed.isUnlocked}
                    className={styles.unlockButton}
                  >
                    {seed.isUnlocked ? 'Already Unlocked' : 
                     canAfford(seed.cost) ? 'Unlock Seed' : 'Not Enough Gold'}
                  </button>
                </div>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
};

export default LandPlotView; 